<div class="new-enquiry-page">
  <!-- Header -->
  <header class="page-header">
    <div class="header-toolbar">
      <button class="back-button" (click)="router.navigate(['/dashboard'])">
        <i class="fas fa-arrow-left"></i>
      </button>
      <h1 class="page-title">Add new enquiry</h1>
      
      <div class="new-location-select" *ngIf="locations.length > 0">
        <label for="location-select" class="location-label"><i class="fas fa-map-marker-alt"></i> Location</label>
        <select 
          id="location-select"
          class="custom-select location-dropdown"
          [(ngModel)]="selectedLocation"
          (change)="onLocationChange($event)"
        >
          <option value="">Select Location</option>
          <option *ngFor="let location of locations" [value]="location.branchId">
            {{ location.branchName }}
          </option>
        </select>
      </div>
    </div>
  </header>

  <div class="page-content" *ngIf="isModalSubmitted">
    <div class="auth">
      <form class="form" [formGroup]="registerForm" (ngSubmit)="onSubmit()">

        <!-- Behalf Enquiry Details -->
        <div class="card mb-4 shadow-sm" style="border-radius: 12px; border: 1px solid #e0e0e0; background-color: #fcfcfc; transition: all 0.3s ease;" *ngIf="behalfNoteDetails">
          <div class="card-header bg-white d-flex justify-content-between align-items-center" 
               style="border-bottom: 1px solid #e0e0e0; border-top-left-radius: 12px; border-top-right-radius: 12px; cursor: pointer; padding: 1rem 1.25rem;"
               (click)="toggleBehalfNoteCollapse()">
            <div class="d-flex align-items-center">
              <div class="icon-circle bg-light d-flex justify-content-center align-items-center rounded-circle me-3" style="width: 40px; height: 40px; border: 1px solid #e0e0e0;">
                <i class="fas fa-hands-helping text-info"></i>
              </div>
              <h5 class="fw-bold mb-0 text-info">Behalf Enquiry Reference</h5>
            </div>
            <i class="fas text-muted" [ngClass]="isBehalfNoteCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
          </div>
          
          <div class="card-body p-4" *ngIf="!isBehalfNoteCollapsed">
            <div class="row g-3">
              <div class="col-12" *ngIf="behalfNoteDetails.veh_no || behalfNoteDetails.text">
                <div class="p-3 rounded bg-white border shadow-sm" style="border-left: 4px solid #17a2b8 !important;">
                  <!-- <div *ngIf="behalfNoteDetails.veh_no" class="mb-2">
                    <span class="text-muted small fw-bold text-uppercase d-block mb-1">Vehicle Info</span>
                    <span class="fs-6">{{ behalfNoteDetails.veh_no }}</span>
                  </div> -->
                  <div *ngIf="behalfNoteDetails.text">
                    <span class="text-muted small fw-bold text-uppercase d-block mb-1">Vehicle Info</span>
                    <span class="fs-6">{{ behalfNoteDetails.text }}</span>
                  </div>
                </div>
              </div>
              
              <div class="col-12 mt-3" *ngIf="behalfNoteDetails.voice_url || (behalfNoteDetails.images && behalfNoteDetails.images.length > 0)">
                <div class="d-flex flex-wrap gap-3">
                  <!-- Audio Player -->
                  <div class="d-inline-flex align-items-center bg-white border shadow-sm rounded-pill px-3 py-2" *ngIf="behalfNoteDetails.voice_url" style="cursor: pointer;" (click)="playAudio(behalfNoteDetails.voice_url)">
                    <i class="fas text-danger me-2" [ngClass]="isPlayingAudio ? 'fa-pause-circle' : 'fa-play-circle'" style="font-size: 1.25rem;"></i>
                    <span class="text-danger fw-bold">{{ isPlayingAudio ? 'Playing...' : 'Play Voice Note' }}</span>
                  </div>
                </div>

                <!-- Image Gallery -->
                <div class="mt-3" *ngIf="behalfNoteDetails.images && behalfNoteDetails.images.length > 0">
                  <span class="text-muted small fw-bold text-uppercase d-block mb-2">Attachments ({{ behalfNoteDetails.images.length }})</span>
                  <div class="d-flex gap-2 flex-wrap">
                    <div *ngFor="let img of behalfNoteDetails.images" class="ratio ratio-1x1 border shadow-sm rounded overflow-hidden" 
                         style="width: 80px; height: 80px; cursor: pointer; background-size: cover; background-position: center; background-color: #f8f9fa;"
                         [style.background-image]="'url(' + (img.img_url || img.url || img) + ')'"
                         (click)="openImageModal(img.img_url || img.url || img)">
                      <div class="d-flex justify-content-center align-items-center bg-dark bg-opacity-25" style="opacity: 0; transition: opacity 0.2s;" onmouseover="this.style.opacity=1" onmouseout="this.style.opacity=0">
                        <i class="fas fa-expand text-white"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Vehicle Details Section -->
        <ng-container>
          <!-- With Registration Number Section -->
          <div *ngIf="registerForm.get('enquiryType')?.value === '1' && (!isVehicleDetailsFullySelected() || isEditingVehicle)">
            <div class="card mb-4 shadow-sm mx-4 mt-3" style="border-radius: 12px; border: 1px solid #e0e0e0; width: calc(100% - 3rem);">
              <div class="card-body p-4">
                <h5 class="fw-bold mb-3"><i class="fas fa-car me-2 text-primary"></i>Vehicle Registration No</h5>
                <div class="form-group">
                  <!-- <label class="form-label text-muted small fw-bold mb-2">REG NO</label> -->
                  <input type="text" formControlName="vehNo" placeholder="vehicle Reg No" class="form-control form-control-lg border shadow-sm rounded-3 py-2 text-uppercase">
                </div>
                <div class="mt-3 text-end">
                  <button type="button" class="btn btn-primary px-4 rounded-3 shadow-sm" (click)="getVehicleDetails()" [disabled]="!registerForm.get('vehNo')?.value || isLoading">
                    <span *ngIf="!isLoading"><i class="fas fa-search me-2"></i>Get Details</span>
                    <span *ngIf="isLoading"><div class="spinner-border spinner-border-sm me-2" role="status"></div>Fetching...</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Step-by-step Vehicle Selection (when not all details selected or editing) -->
          <div class="vehicle-selection-container" *ngIf="(registerForm.get('enquiryType')?.value !== '1' || showVehicleStepper) && (!isVehicleDetailsFullySelected() || isEditingVehicle)">
            
            <!-- Left: Selection Summary -->
            <div class="selection-summary">
              <h3>Your selection</h3>
              
              <div class="summary-item" *ngIf="selectedVehicle.make">
                <div class="summary-icon">
                  <i class="fas fa-car"></i>
                </div>
                <div class="summary-content">
                  <span class="summary-value">{{ selectedVehicle.make }}</span>
                </div>
                <button type="button" class="summary-edit" (click)="editStep('make')">
                  <i class="fas fa-edit"></i>
                </button>
              </div>

              <div class="summary-item" *ngIf="selectedVehicle.model">
                <div class="summary-icon">
                  <i class="fas fa-car"></i>
                </div>
                <div class="summary-content">
                  <span class="summary-value">{{ selectedVehicle.model }}</span>
                </div>
                <button type="button" class="summary-edit" (click)="editStep('model')">
                  <i class="fas fa-edit"></i>
                </button>
              </div>

              <div class="summary-item" *ngIf="selectedVehicle.fuel">
                <div class="summary-icon">
                  <i class="fas fa-gas-pump"></i>
                </div>
                <div class="summary-content">
                  <span class="summary-value">{{ selectedVehicle.fuel }}</span>
                </div>
                <button type="button" class="summary-edit" (click)="editStep('fuel')">
                  <i class="fas fa-edit"></i>
                </button>
              </div>

              <div class="summary-item" *ngIf="selectedVehicle.transmission">
                <div class="summary-icon">
                  <i class="fas fa-cog"></i>
                </div>
                <div class="summary-content">
                  <span class="summary-value">{{ selectedVehicle.transmission }}</span>
                </div>
                <button type="button" class="summary-edit" (click)="editStep('transmission')">
                  <i class="fas fa-edit"></i>
                </button>
              </div>

              <div class="summary-item" *ngIf="selectedVehicle.year">
                <div class="summary-icon">
                  <i class="fas fa-calendar"></i>
                </div>
                <div class="summary-content">
                  <span class="summary-value">{{ selectedVehicle.year }}</span>
                </div>
                <button type="button" class="summary-edit" (click)="editStep('year')">
                  <i class="fas fa-edit"></i>
                </button>
              </div>

              <div class="summary-item" *ngIf="selectedVehicle.variant">
                <div class="summary-icon">
                  <i class="fas fa-car"></i>
                </div>
                <div class="summary-content">
                  <span class="summary-value">{{ selectedVehicle.variant }}</span>
                </div>
                <button type="button" class="summary-edit" (click)="editStep('variant')">
                  <i class="fas fa-edit"></i>
                </button>
              </div>
            </div>

            <!-- Right: Selection Options Panel -->
            <div class="selection-options-panel">
              <div class="panel-header">
                <button type="button" class="back-btn-custom" (click)="goBackStep()" *ngIf="currentVehicleStep !== 'make'">
                  <i class="fas fa-chevron-left"></i>
                </button>
                <span class="header-title">
                  {{ currentVehicleStep === 'make' ? 'Select Car Brand' :
                     currentVehicleStep === 'model' ? 'Select Car Model' :
                     currentVehicleStep === 'fuel' ? 'Select Car Fuel Type' :
                     currentVehicleStep === 'transmission' ? 'Select Transmission' :
                     currentVehicleStep === 'year' ? 'Select Year' :
                     'Select Variant' }}
                </span>
                
                <!-- Stepper Dots -->
                <div class="stepper-dots">
                  <div class="dot" [class.active]="currentVehicleStep === 'make'" [class.completed]="isStepCompleted('make')">
                    <i class="fas fa-check" *ngIf="isStepCompleted('make')"></i>
                  </div>
                  <div class="dot" [class.active]="currentVehicleStep === 'model'" [class.completed]="isStepCompleted('model')">
                    <i class="fas fa-check" *ngIf="isStepCompleted('model')"></i>
                  </div>
                  <div class="dot" [class.active]="currentVehicleStep === 'fuel'" [class.completed]="isStepCompleted('fuel')">
                    <i class="fas fa-check" *ngIf="isStepCompleted('fuel')"></i>
                  </div>
                  <div class="dot" [class.active]="currentVehicleStep === 'transmission'" [class.completed]="isStepCompleted('transmission')">
                    <i class="fas fa-check" *ngIf="isStepCompleted('transmission')"></i>
                  </div>
                  <div class="dot" [class.active]="currentVehicleStep === 'year'" [class.completed]="isStepCompleted('year')">
                    <i class="fas fa-check" *ngIf="isStepCompleted('year')"></i>
                  </div>
                  <div class="dot" [class.active]="currentVehicleStep === 'variant'" [class.completed]="isStepCompleted('variant')">
                    <i class="fas fa-check" *ngIf="isStepCompleted('variant')"></i>
                  </div>
                </div>
              </div>

              <div class="panel-content">
                <!-- Make Selection -->
                <div class="options-grid" *ngIf="currentVehicleStep === 'make'">
                  <div class="option-card" 
                       *ngFor="let make of makeList" 
                       (click)="selectBrandStep(make)"
                       [class.selected]="selectedVehicle.make === make.title">
                    <div class="brand-icon" *ngIf="make.icon" [style.background-position]="make.icon"></div>
                    <div class="brand-image" *ngIf="!make.icon && make.img_path">
                      <img [src]="make.img_path" [alt]="make.title">
                    </div>
                    <div class="brand-icon-fallback" *ngIf="!make.icon && !make.img_path">
                      <i class="fas fa-car"></i>
                    </div>
                    <span class="option-text">{{ make.title }}</span>
                  </div>
                </div>

                <!-- Model Selection -->
                <div class="options-grid-two" *ngIf="currentVehicleStep === 'model'">
                  <div class="option-card-horizontal" 
                       *ngFor="let model of modelList"
                       (click)="selectModelStep(model)"
                       [class.selected]="selectedVehicle.model === model.name">
                    <span class="option-text">{{ model.name }}</span>
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>

                <!-- Fuel Type Selection -->
                <div class="options-grid-two" *ngIf="currentVehicleStep === 'fuel'">
                  <div class="option-card-horizontal" 
                       *ngFor="let fuel of fuelTypeList"
                       (click)="selectFuelTypeStep(fuel)"
                       [class.selected]="selectedVehicle.fuel === fuel.name">
                    <span class="option-text">{{ fuel.name }}</span>
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>

                <!-- Transmission Selection -->
                <div class="options-grid-two" *ngIf="currentVehicleStep === 'transmission'">
                  <div class="option-card-horizontal" 
                       *ngFor="let transmission of transmissionTypeList"
                       (click)="selectTransmissionStep(transmission)"
                       [class.selected]="selectedVehicle.transmission === transmission.name">
                    <span class="option-text">{{ transmission.name }}</span>
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>

                <!-- Year Selection -->
                <div class="options-grid-two" *ngIf="currentVehicleStep === 'year'">
                  <div class="option-card-horizontal" 
                       *ngFor="let year of regYearList"
                       (click)="selectYearStep(year)"
                       [class.selected]="selectedVehicle.year == year.year">
                    <span class="option-text">{{ year.year }}</span>
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>

                <!-- Variant Selection -->
                <div class="options-grid-two" *ngIf="currentVehicleStep === 'variant'">
                  <div class="option-card-horizontal" 
                       *ngFor="let variant of variantList"
                       (click)="selectVariantStep(variant)"
                       [class.selected]="selectedVehicle.variant == variant.name">
                    <span class="option-text">{{ variant.name }}</span>
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>
              </div>

              <!-- Compact Voice Input Card -->
              <div class="voice-card-compact mx-4 mb-4" *ngIf="!selectedVehicle.make && !selectedVehicle.model">
                <div class="voice-example-banner p-3 rounded-top-4" style="background-color: #e8f5f2; border: 1px solid #d1f0e8; border-bottom: none;">
                  <div class="d-flex align-items-center mb-3">
                    <div class="icon-circle bg-white shadow-sm d-flex justify-content-center align-items-center rounded-circle me-3" style="width: 40px; height: 40px;">
                      <i class="fas fa-lightbulb text-warning"></i>
                    </div>
                    <div>
                      <h5 class="mb-0 fw-bold">Sample Voice Input</h5>
                      <small class="text-muted">Listen to get it right!</small>
                    </div>
                  </div>
                  <div class="d-flex align-items-center justify-content-between bg-white p-3 rounded-3 shadow-sm border flex-wrap gap-2">
                    <div class="d-flex align-items-center">
                      <i class="fas fa-comment-dots text-success me-3 fs-4"></i>
                      <p class="mb-0 fst-italic" style="font-size: 0.9rem;">"Maruti Swift Diesel Manual 2022 VDI, I need Front brake pads and clutch plate"</p>
                    </div>
                    <button type="button" class="btn btn-sm btn-success rounded-pill px-3 d-flex align-items-center flex-shrink-0" (click)="playExampleVoice($event)">
                      <i class="fas me-2" [ngClass]="isPlayingExample ? 'fa-pause-circle' : 'fa-play-circle'"></i>
                      <span>{{ isPlayingExample ? 'Playing...' : 'Play Example' }}</span>
                    </button>
                  </div>
                </div>

                <div class="voice-compact-body p-4 rounded-bottom-4 shadow-sm border text-center" style="background-color: #ffffff; border-color: #d1f0e8;">
                  <input #existingAudioInput type="file" accept="audio/*" hidden (change)="onExistingAudioSelected($event)">
                  
                  <!-- No Recording Yet -->
                  <div class="d-flex justify-content-center gap-3" *ngIf="!recordedAudioBlob && !isRecording">
                    <button type="button" class="btn btn-success d-flex flex-column align-items-center justify-content-center py-3 px-4 rounded-4 shadow-sm border-0" style="background: linear-gradient(135deg, #28a745 0%, #20c997 100%);" (click)="startVehicleRecording()">
                      <i class="fas fa-microphone fs-2 mb-2 text-white"></i>
                      <span class="fw-bold text-white">Start Recording</span>
                    </button>
                    <button type="button" class="btn btn-outline-secondary d-flex flex-column align-items-center justify-content-center py-3 px-4 rounded-4 shadow-sm bg-light border-0" (click)="existingAudioInput.click()">
                      <i class="fas fa-folder-open fs-2 mb-2 text-secondary"></i>
                      <span class="fw-bold text-secondary">Choose Audio File</span>
                    </button>
                  </div>

                  <!-- Currently Recording -->
                  <div class="d-flex flex-column align-items-center justify-content-center" *ngIf="isRecording">
                    <div class="d-flex align-items-center mb-3">
                      <i class="fas fa-circle text-danger me-2" style="animation: pulse 1.5s infinite;"></i>
                      <span class="fw-bold text-danger fs-5">Recording...</span>
                    </div>
                    <button type="button" class="btn btn-danger rounded-circle shadow d-flex justify-content-center align-items-center" style="width: 80px; height: 80px;" (click)="stopVehicleRecording()">
                      <i class="fas fa-stop fs-2"></i>
                    </button>
                  </div>

                  <!-- Recording Complete -->
                  <div class="d-flex justify-content-center gap-4" *ngIf="recordedAudioBlob && !isRecording">
                    <button type="button" class="btn btn-outline-success rounded-circle shadow-sm d-flex justify-content-center align-items-center" style="width: 60px; height: 60px;" (click)="playRecordedAudio()">
                      <i class="fas fs-3" [ngClass]="isPlayingRecording ? 'fa-pause' : 'fa-play'"></i>
                    </button>
                    <button type="button" class="btn btn-success rounded-circle shadow-sm d-flex justify-content-center align-items-center" style="width: 60px; height: 60px; background: linear-gradient(135deg, #28a745 0%, #20c997 100%); border: none;" (click)="sendRecordedAudio()" [disabled]="isLoading">
                      <i class="fas fa-paper-plane fs-3 text-white" *ngIf="!isLoading"></i>
                      <div class="spinner-border text-white" style="width: 1.5rem; height: 1.5rem;" role="status" *ngIf="isLoading"></div>
                    </button>
                    <button type="button" class="btn btn-outline-danger rounded-circle shadow-sm d-flex justify-content-center align-items-center" style="width: 60px; height: 60px;" (click)="deleteRecording()">
                      <i class="fas fa-trash-alt fs-3"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <!-- Vehicle Details Summary (After selection complete) -->
          <div class="vehicle-details-summary" *ngIf="isVehicleDetailsFullySelected() && !isEditingVehicle">
            <div class="card vehicle-details-card">
              <div class="card-header">
                <i class="fas fa-car"></i>
                <span>Vehicle Details</span>
              </div>

              <!-- Vehicle Display Section -->
              <div class="vehicle-display-section mx-5 my-2">
                <div class="vehicle-info">
                  <div class="vehicle-header">
                    <div class="vehicle-icon-badge">
                      <i class="fas fa-car"></i>
                    </div>
                    <div class="vehicle-details">
                      <h3 class="vehicle-title">
                        {{ selectedVehicle.make }} {{ selectedVehicle.model }} 
                        <span class="variant-badge" *ngIf="selectedVehicle.variant">{{ selectedVehicle.variant }}</span>
                      </h3>
                      <div class="vehicle-specs">
                        <span class="spec-item" *ngIf="selectedVehicle.fuel">
                          <i class="fas fa-gas-pump"></i>
                          {{ selectedVehicle.fuel }}
                        </span>
                        <span class="spec-divider" *ngIf="selectedVehicle.fuel && selectedVehicle.year">•</span>
                        <span class="spec-item" *ngIf="selectedVehicle.year">
                          <i class="fas fa-calendar-alt"></i>
                          {{ selectedVehicle.year }}
                        </span>
                        <span class="spec-divider" *ngIf="selectedVehicle.year && selectedVehicle.transmission">•</span>
                        <span class="spec-item" *ngIf="selectedVehicle.transmission">
                          <i class="fas fa-cogs"></i>
                          {{ selectedVehicle.transmission }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <button type="button" class="edit-vehicle-btn" (click)="editVehicleDetails()">
                  <i class="fas fa-pen"></i>
                  <span>Edit</span>
                </button>
              </div>

              <!-- Additional Vehicle Details Card -->
              <div class="mx-5 my-2 mt-4">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <div>
                    <span class="fw-bold me-2" style="font-size: 1.1rem;">Additional Vehicle Details</span>
                    <span class="badge bg-secondary" style="font-size: 0.75rem;">Optional</span>
                  </div>
                  <button type="button" class="btn btn-link text-success text-decoration-none p-0 d-flex align-items-center fw-bold" (click)="toggleAdditionalDetails()">
                    <i class="fas me-1" [ngClass]="showAdditionalDetails ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
                    {{ showAdditionalDetails ? 'Close' : 'Add' }}
                  </button>
                </div>
                
                <div class="card bg-light border-0" [formGroup]="registerForm" *ngIf="showAdditionalDetails" style="border-radius: 12px;">
                  <div class="card-body">
                    <div class="row g-3">
                      <div class="col-md-4">
                        <label class="form-label text-muted small fw-bold mb-1">Registration No</label>
                        <input type="text" formControlName="vehNo" placeholder="Enter registration number" class="form-control form-control-sm border-0 shadow-sm rounded-3 py-2">
                      </div>

                      <div class="col-md-4">
                        <label class="form-label text-muted small fw-bold mb-1">Chassis No</label>
                        <input type="text" formControlName="chassisNo" placeholder="Enter chassis number" class="form-control form-control-sm border-0 shadow-sm rounded-3 py-2">
                      </div>

                      <div class="col-md-4">
                        <label class="form-label text-muted small fw-bold mb-1">Color</label>
                        <input type="text" formControlName="color" placeholder="Enter color" class="form-control form-control-sm border-0 shadow-sm rounded-3 py-2">
                      </div>
                    </div>
                    <p class="text-muted small mb-0 mt-3 fst-italic"><i class="fas fa-info-circle me-1"></i>Add any extra vehicle information you have. Leave blank if unavailable.</p>
                  </div>
                </div>
              </div>

              <!-- Vehicle Attachments -->
              <div class="attachment-section mx-5 my-2">

                <div class="attachment-section-title">
                  <i class="fas fa-paperclip"></i>
                  <span>Vehicle Documents Upload</span>
                </div>

                <div class="attachment-header">
                  <select 
                    class="attachment-type-select"
                    (change)="onUploadTypeChange($event)"
                  >
                    <option value="">Select Attachment Type</option>
                    <option *ngFor="let item of vehicleDocList" [value]="item.id">
                      {{ item.value }}
                    </option>
                  </select>
                  <button type="button" class="upload-button" (click)="newVehicleAttachment()">
                    Upload
                  </button>
                </div>

                <table class="attachment-table" *ngIf="vehicleAttachmentList.length > 0">
                  <thead>
                    <tr>
                      <th>Type</th>
                      <th>Option</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let attachment of vehicleAttachmentList; let i = index; trackBy: trackByFn">
                      <td>{{ getAttachmentValue(attachment.attachmentType) }}</td>
                      <td class="actions">
                        <button  type="button" class="icon-button" (click)="showVehicleAttachment(i,attachment)">
                          <i class="fas fa-eye"></i>
                        </button>
                        <button type="button" class="icon-button delete" (click)="removeVehicleAttachment(i, attachment.attachmentId)">
                          <i class="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Shared Bulk Upload / Manual Entry Logic -->
            <ng-container *ngIf="isBulkupload; else manualEntryBlock">
              <ng-container *ngTemplateOutlet="bulkUploadBlock"></ng-container>
            </ng-container>
          </div>

        </ng-container>

        <!-- Manual Entry Section -->
        <ng-template #manualEntryBlock>
          <ng-container *ngTemplateOutlet="manualEntryTable"></ng-container>
        </ng-template>

        <ng-template #bulkUploadBlock>
          <div class="card upload-section shadow border-0 rounded-4 overflow-hidden">
            
            <!-- Header -->
             <div class="part-details-card">
                <div class="card-header">
                   <i class="fas fa-tools"></i>
                   <span>Parts Details</span>
                </div>
            </div>
        
            <!-- Body -->
            <div class="card-body p-4">

              <div class="d-flex align-items-center gap-2 mb-3">
                <button 
                  class="btn btn-primary btn-sm px-3 py-2 d-flex align-items-center" 
                  (click)="downloadTemplate()" 
                  title="Download Excel Template"
                  type="button"
                >
                  <i class="fas fa-arrow-down me-2"></i>
                  <span>Download Excel Template</span>
                </button>
              </div>
              
              <!-- Line 2: Upload -->
              <div class="d-flex align-items-center gap-3 mb-3">
                <input #fileInput type="file" accept=".xlsx,.xls" hidden (change)="handleFileChange($event)" />
              
                <button 
                  class="btn btn-success btn-sm px-3 py-2 d-flex align-items-center" 
                  (click)="fileInput.click()"
                  title="Select Excel File"
                  type="button"
                >
                  <i class="fas fa-upload me-2"></i>
                  <span>Select File</span>
                </button>
              </div>
              
              <div *ngIf="selectedExcelFile" class="d-flex align-items-center gap-2 mb-3">
                <span class="badge bg-secondary d-flex align-items-center text-truncate" style="max-width: 160px;">
                  <i class="fas fa-file-excel me-1"></i>
                  {{ selectedExcelFile.name }}
                </span>
                <button 
                  class="btn btn-link text-danger p-0 text-start" 
                  (click)="clearSelectedExcelFile()" 
                  type="button" 
                  title="Remove selected file"
                >
                  <i class="fas fa-times-circle fa-lg"></i>
                </button>
              <button
                  class="btn btn-success"
                  (click)="onExcelUpload()"
                  [disabled]="!selectedExcelFile"
                  type="button"
                >
                  <i class="fas fa-upload me-2"></i>Upload
                </button>
              </div>

              <div class="pt-4 border-top">
                  <ng-container *ngTemplateOutlet="manualEntryTable"></ng-container>
              </div>
               
            </div>
          </div>
        </ng-template>

        <!-- Parts Table (Reused for both manual/bulk entry) -->
        <ng-template #manualEntryTable>
          <div class="card parts-details-card">

            <table class="parts-table">
              <thead>
                <tr>
                  <th style="width: 20%; text-align: center;">Part No</th>
                  <th style="width: 50%; text-align: center;">Description</th>
                  <th style="width: 15%; text-align: center;">Qty</th>
                  <th style="width: 15%; text-align: center;">Opt</th>
                </tr>
              </thead>
              <tbody formArrayName="partDetails">
                <tr *ngFor="let part of partDetails.controls; let i = index" [formGroupName]="i">
                  <td style="width: 20%; position: relative;">
                    <input type="text" formControlName="partNo" class="input-field" autocomplete="off"
                           (input)="onPartNoInput(i, $event)"
                           (focus)="onPartNoFocus(i, $event)"
                           (blur)="hidePartNoSuggestions()" />
                    <!-- Widened dropdown spanning Part No + Description columns -->
                    <div *ngIf="activePartNoIndex === i && partNoSuggestions.length > 0"
                         style="position: absolute; top: 100%; left: 0; width: 450px; z-index: 2000; background: #fff; border-radius: 10px; box-shadow: 0 8px 30px rgba(0,0,0,0.15); border: 1px solid #e0e0e0; overflow: hidden;">
                      <div style="background: linear-gradient(90deg, #1a9a72, #26c98a); padding: 8px 14px; display: flex; justify-content: space-between; align-items: center;">
                        <span style="color:#fff; font-size: 0.78rem; font-weight: 600; letter-spacing: 0.4px;">PART CODE</span>
                        <span style="color:#fff; font-size: 0.78rem; font-weight: 600; letter-spacing: 0.4px;">DESCRIPTION &amp; MRP</span>
                      </div>
                      <ul style="list-style: none; margin: 0; padding: 0; max-height: 220px; overflow-y: auto;">
                        <li *ngFor="let suggestion of partNoSuggestions; let si = index"
                            (mousedown)="selectPartNo(suggestion, i)"
                            style="display: flex; align-items: center; justify-content: space-between; padding: 9px 14px; cursor: pointer; border-bottom: 1px solid #f0f0f0; transition: background 0.15s;"
                            onmouseover="this.style.background='#f0faf6'" onmouseout="this.style.background='#fff'">
                          <div style="display: flex; align-items: center; gap: 10px; flex: 1; min-width: 0;">
                            <div style="background: #e8f8f2; border-radius: 6px; padding: 4px 8px; flex-shrink: 0;">
                              <span style="font-size: 0.8rem; font-weight: 700; color: #1a9a72; font-family: monospace;">{{ suggestion.item_code }}</span>
                            </div>
                            <span style="font-size: 0.8rem; color: #444; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ suggestion.item_description }}</span>
                          </div>
                          <span style="font-size: 0.78rem; font-weight: 600; color: #e67e22; margin-left: 10px; flex-shrink: 0;">₹{{ suggestion.mrp }}</span>
                        </li>
                      </ul>
                    </div>
                  </td>
                  <td style="position: relative; width: 50%;">
                    <input 
                      type="text" 
                      formControlName="partDescription" 
                      class="input-field" 
                      autocomplete="off"
                    />
                    <div class="error-text" *ngIf="getPartError(i, 'partDescription')">
                       {{ getPartError(i, 'partDescription') }}
                    </div>
                  </td>
                  <td style="width: 15%;">
                    <input type="number" formControlName="qty" class="input-field" (keypress)="allowOnlyNumbers($event)"
                     (input)="onQtyInput(i)"
                    />
      
                      <div class="error-text" *ngIf="getPartError(i, 'qty')">
                        {{ getPartError(i, 'qty') }}
                      </div>
                  </td>
                  <td class="actions" style="width: 15%;">
                    <button type="button" class="icon-button" *ngIf="!part.value.partAttachmentId" (click)="addPartImage(i)">
                      <i class="fas fa-paperclip"></i>
                    </button>
                    <button type="button" class="icon-button" *ngIf="part.value.partAttachmentId" (click)="showPartDetailsAttachment(i, part)">
                      <i class="fas fa-eye"></i>
                    </button>
                    <button type="button" class="icon-button delete" *ngIf="i !== 0" (click)="removePart(i)">
                      <i class="fas fa-trash"></i>
                    </button>
                    <!-- Info icon for definition -->
                    <span class="info-icon-wrapper" *ngIf="part.value.partDefinition">
                      <i class="fas fa-info-circle info-icon"></i>
                      <span class="definition-tooltip">{{ part.value.partDefinition }}</span>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="mt-3 text-start ps-3">
              <button type="button" class="btn btn-sm btn-outline-success rounded-pill px-3 fw-bold shadow-sm" (click)="addPart()">
                <i class="fas fa-plus me-1"></i> Add Another part
              </button>
            </div>

            <div class="form-actions text-end mt-3">
              <button class="btn btn-success" type="submit" [disabled]="isLoading || !isAnyPartFilled">
                <div class="spinner" *ngIf="isLoading"></div>
                <span>Submit</span>
              </button>
            </div>
          </div>
        </ng-template>


      </form>
    </div>
  </div>
</div>

<ng-template #excelPreviewModal let-modal>
  <form #excelForm="ngForm" (ngSubmit)="confirmExcelData(excelForm, modal)" novalidate>
    <div class="modal-header">
      <h5 class="modal-title">Preview Excel Data</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>

    <div class="modal-body">
      <table class="table table-bordered table-striped table-sm">
        <thead>
          <tr>
            <th>Part No</th>
            <th>Description <span class="text-danger">*</span></th>
            <th>Qty <span class="text-danger">*</span></th>
            <th>Opt</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of excelPreview; let i = index">
            <td>
              <input
              [(ngModel)]="row.partNo"
              name="partno{{i}}"
              class="form-control"
            />
            </td>
            <td>
              <input
                [(ngModel)]="row.partDescription"
                name="desc{{i}}"
                class="form-control"
                required
              />
              <div class="text-danger small" *ngIf="excelForm.submitted && !row.partDescription">
                Description is required
              </div>
            </td>
            <td>
              <input
                type="number"
                [(ngModel)]="row.qty"
                name="qty{{i}}"
                class="form-control"
                (keypress)="allowOnlyNumbers($event)"
                required
              />
              <div class="text-danger small" *ngIf="excelForm.submitted && isInvalidQty(row.qty)">
                Qty is required
              </div>
            </td>
            <td class="actions">
              <button type="button" class="btn btn-link text-danger p-0" (click)="removeExcelPreviewRow(i)">
                <i class="fas fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
      <button type="submit" class="btn btn-primary">
        Confirm & Patch
      </button>
    </div>
  </form>
</ng-template>

<!-- Behalf Note Fullscreen Image Modal -->
<div class="modal-backdrop fade show" *ngIf="selectedImage" (click)="closeImageModal()" style="z-index: 1040;"></div>
<div class="modal fade show d-block" tabindex="-1" *ngIf="selectedImage" style="z-index: 1050;">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content bg-transparent border-0">
      <div class="modal-header border-0 pb-0 justify-content-end">
        <button type="button" class="btn-close btn-close-white shadow-none fs-4" (click)="closeImageModal()"></button>
      </div>
      <div class="modal-body text-center p-0 pt-2 pb-4">
        <img [src]="selectedImage" class="img-fluid rounded shadow-lg" style="max-height: 85vh; object-fit: contain;">
      </div>
    </div>
  </div>
</div>